// Providers
export { WalletProvider } from "./WalletProvider";
export { WalletModalProvider } from "./WalletModal";
export type { SolomonE2EChainOverride, SolomonE2EOverrides, SolomonE2EWalletOverride, WalletBalanceKey } from "./types";

// Custom hooks with solomon-labs types
export { useWallet } from "./hooks/useWallet";
export type { WalletState } from "./types";
export {
    useTokenBalances,
    useTokenBalancesActions,
    useTokenBalancesController,
    useTokenBalancesData
} from "./hooks/useTokenBalances";
export type { ReconcileBalancesOptions } from "./utils/balanceReconciliation";
export type {
    UseTokenBalancesActionsResult,
    UseTokenBalancesControllerResult,
    UseTokenBalancesDataResult
} from "./hooks/useTokenBalances";

// Modal hooks
export { useWalletModal, useUnifiedWalletContext } from "./WalletModal";

// Re-export ConnectorKit hooks for advanced use cases
export { useConnector, useTransactionSigner } from "@solana/connector/react";
